import React from "react";
import { Box, Typography, Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { SignInDetails } from "../../components/authentication/signin-details";

const Login: React.FC = () => {
  const theme = useTheme();
  
  return (
    <Box
      sx={{
        background: "white",
        paddingTop: 2,
      }}
    >
      <Stack
        direction={"column"}
        justifyContent={"space-between"}
        sx={{ margin: 2, gap: 2 }}
      >
        <Box sx={{ width: "80%", mx: "auto" }}>
          <Typography
            color="black"
            variant="h3"
            sx={{
              fontWeight: 500,
              letterSpacing: "-0.23999999463558197px",
            }}
          >
            Welcome back!
          </Typography>
          <Typography variant="body1" sx={{ color: "#7991A4" }}>
            Sign into account
          </Typography>
        </Box>

        <SignInDetails />
        <Typography
          variant="caption"
          sx={{
            color: theme.palette.secondary.contrastText,
            textAlign: "center",
            mt: 2,
            width: "80%",
            mx: "auto",
          }}
        >
          By registering you agree to our Terms & Conditions, Privacy Notice,
          and EULA
        </Typography>
      </Stack>
    </Box>
  );
};

export default Login;
